export default __webpack_public_path__ + "static/media/creditcard-launch-trademark.c20ade66.svg";